import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

export default function Spinner({
  className,
  isCentered,
  testId,
  small,
  medium,
}) {
  // @TODO refactor to use size as prop
  return (
    <SpinnerStyled
      isCentered={isCentered}
      medium={medium}
      small={small}
      className={className}
      data-testid={testId}
    />
  );
}

const size = '40px';
const loaderSize = '60px';
const loaderRingSize = '4px';
const loaderRingColor = '#b7b7b7';
const loaderSpinColor = '#1a183b';

const centeredStyled = `
  position: absolute;
  bottom: 50%;
  right: 50%;
  transform: translate(50%, 50%);
`;

const smallStyles = `
  height: calc(${size} / 4);
  width: calc(${size} / 4);
  margin: 8px auto;

  ::before {
    width: calc(${loaderSize} / 4);
    height: calc(${loaderSize} / 4);
  }
`;

const mediumStyles = `
  height: calc(${size} / 2);
  width: calc(${size} / 2);
  margin: 8px auto;

  ::before {
    width: calc(${loaderSize} / 2);
    height: calc(${loaderSize} / 2);
  }
`;

const SpinnerStyled = styled.div`
  height: ${size};
  width: ${size};
  position: relative;
  margin: var(--base-spacing-unit) auto;

  ::before {
    margin: -1px;
    content: '';
    box-sizing: border-box;
    position: absolute;
    left: 0;
    width: ${loaderSize};
    height: ${loaderSize};
    border-radius: 50%;
    border: ${loaderRingSize} solid ${loaderRingColor};
    border-top-color: ${loaderSpinColor};
    animation: spin 0.6s linear infinite;
  }

  ${props =>
    props.isCentered
      ? css`
          ${centeredStyled};
        `
      : ''};

  ${props =>
    props.small
      ? css`
          ${smallStyles};
        `
      : ''};

  ${props =>
    props.medium
      ? css`
          ${mediumStyles};
        `
      : ''};
`;

Spinner.defaultProps = {
  isCentered: false,
  small: false,
  medium: false,
  testId: 'loader-spinner',
  className: '',
};

Spinner.propTypes = {
  isCentered: PropTypes.bool,
  small: PropTypes.bool,
  medium: PropTypes.bool,
  testId: PropTypes.string,
  className: PropTypes.string,
};
